import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {TechnicalDocument, TechnicalDocumentsProvider} from '../../../../../providers/technical-documents/technical-documents.provider';
import {StdAddModalComponent} from './components/std-add-modal/std-add-modal.component';

@Component({
    selector: 'app-std-objects',
    template: `
        <std-add-modal [type]="'По объектам'"></std-add-modal>
        <app-std-layout>
            <ng-container *ngFor="let title of getTitles()">
                <ng2-accordion [title]="title" [actionLink]="'+ Добавить НТД'" (action)="showAddModal(title)">
                    <std-table [documents]="documents[title]"></std-table>
                </ng2-accordion>
            </ng-container>
        </app-std-layout>
    `
})

export class StdObjectsComponent extends AbstractFields implements OnInit {
    @ViewChild(StdAddModalComponent) public modal: StdAddModalComponent;

    public documents: DocumentsValues = {};

    constructor(
        private documentsProvider: TechnicalDocumentsProvider,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        const values = this.form.get('list').value as StdObjectsFormValue;
        const rawDocuments = this.documentsProvider.getDocumentsWithObject();

        Object.keys(values).forEach(key => {
            const ids: number[] = values[key];
            this.documents[key] = rawDocuments.filter(doc => ids.includes(doc.id));
        });
    }

    getTitles() {
        return Object.keys(this.documents);
    }

    showAddModal(title: string) {
        this.modal.showModal(title);
    }
}

interface DocumentsValues {
    [key: string]: TechnicalDocument[];
}

interface StdObjectsFormValue {
    list: {
        [key: string]: number[]
    };
}
